import { useParams } from 'react-router-dom';

import { IndicatorFactType, PlotReportFactLabelFilter } from '@/api/rest/resources/types/fact';
import { useHiddenFactConfigurationByFactType } from '@/hooks/useWidgetConfigurationByOrganizationId';

import { useDashboardByProjectId } from './useDashboardByProjectId';
import { getFact } from './utils';

/**
 * @param projectId Falls back to the projectId in the URL if no value is provided.
 */
export const useProjectFact = <T = unknown>(
  type: IndicatorFactType,
  projectIdArg?: string | null,
  labelFilters?: PlotReportFactLabelFilter,
) => {
  const routeParams = useParams();
  const projectId = projectIdArg ?? routeParams.projectId;
  const isFactHidden = useHiddenFactConfigurationByFactType(type);

  if (!projectId) {
    throw new Error('Missing URL param: projectId');
  }

  const dashboardData = useDashboardByProjectId(projectId, labelFilters).data;

  return getFact<T>(dashboardData, type, labelFilters, isFactHidden);
};
